import TabGroupSeguros from '@/components/molecules/TabGroupSeguros';
import { SeguroTabs } from '@/data/misc/seguros-tabs';

export default function SeguroAutoPage() {
  return <TabGroupSeguros tab={SeguroTabs['seguro-santander-auto'].id} />;
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
